import swal from 'sweetalert2'

import { SidebarModalListItem } from '@domain-group/suit-theme'
import type { UseFormPayload } from '@domain-group/react-hooks'

import type { QuickLink } from '../hooks/useManageEntityQuickLinksModal'

const confirmDelete = (
  manageEntityQuickLink: (action: string, quicklink: QuickLink) => void,
  quickLink: QuickLink,
) => {
  swal
    .fire({
      confirmButtonColor: '#DD6B55',
      confirmButtonText: 'Yes, remove it.',
      icon: 'warning',
      showCancelButton: true,
      text: 'Are you sure?',
      title: 'Remove Quick Link?',
    })
    .then(({ value }) => {
      if (value){
        manageEntityQuickLink('delete', quickLink)
      }
    })
}

interface QuickLinkListItemProps {
  callbacks: {
    selectQuickLink: (quicklink: QuickLink) => void,
    manageEntityQuickLink: (action: string, quicklink: UseFormPayload['entityState']) => void,
  },
  quickLink: QuickLink,
}

const QuickLinkListItem = (props: QuickLinkListItemProps) => {
  const {
    callbacks: {
      manageEntityQuickLink,
      selectQuickLink,
    },
    quickLink,
  } = props

  const { title } = quickLink || {}

  return (
    <SidebarModalListItem title={title}>
      {/*
       // @ts-expect-error TS2339 */}
      <SidebarModalListItem.Actions>
        {/*
         // @ts-expect-error TS2339 */}
        <SidebarModalListItem.Icon
          marginRight="medium"
          onClick={() => selectQuickLink(quickLink)}
          type="edit"
        />

        {/*
         // @ts-expect-error TS2339 */}
        <SidebarModalListItem.Icon
          onClick={() => confirmDelete(manageEntityQuickLink, quickLink)}
          type="delete"
        />
        {/*
       // @ts-expect-error TS2339 */}
      </SidebarModalListItem.Actions>
    </SidebarModalListItem>
  )
}

export default QuickLinkListItem
